import TextField from '@components/v2/form/TextField/TextField';
import Box from '@mui/material/Box';
import { memo } from 'react';
import LangEnum from '../../../lang/LangEnum';
import { useTranslation } from '../../../modules/translation/TranslationContext';
import { FilterOptions } from '../../FilterV3/filter.types';
import useWidth from '../../Hooks/useWidth';
import OptionsList from './components/OptionsList/OptionsList';
import { Option, OptionValue } from './components/OptionsList/optionsList.types';
import SearchFieldWrapper from './components/SearchFieldWrapper/SearchFieldWrapper';
import useMultiOptionsSelectorV2 from './hooks/useMultiOptionsSelectorV2';

export interface StaticOptionsSelectorV2Props extends FilterOptions<OptionValue> {
  options: Option[];
  value: OptionValue[];
  canReorder?: boolean;
  fullWidth?: boolean;
  fillHeight?: boolean;
}

const StaticOptionsSelectorV2 = ({
  options,
  onChange,
  value,
  canReorder,
  fullWidth,
  fillHeight,
}: StaticOptionsSelectorV2Props) => {
  const { mobileWidth } = useWidth();
  const { translate } = useTranslation();
  const desktopWidth = fullWidth ? '100%' : 325;
  const desktopMaxHeight = mobileWidth ? '100%' : '500px';

  const { handleSelectMultiple, textFieldRef, onChangeQuery, query } = useMultiOptionsSelectorV2({
    onChange,
    value,
  });

  return (
    <Box
      sx={{
        overflow: fillHeight ? 'hidden' : 'auto',
        overscrollBehavior: 'none',
        maxHeight: fillHeight ? 'none' : desktopMaxHeight,
        flexGrow: fillHeight || mobileWidth ? 1 : 0,
        minHeight: fillHeight ? 0 : undefined,
        gap: '5px',
        display: 'flex',
        flexDirection: 'column',
        width: mobileWidth ? 'auto' : desktopWidth,
      }}
    >
      <SearchFieldWrapper sx={fillHeight ? { paddingRight: 1.5 } : undefined}>
        <TextField
          size="small"
          label={translate(LangEnum.GLOBAL_SEARCH)}
          value={query}
          ref={textFieldRef}
          onChange={(event) => onChangeQuery(event.target.value)}
        />
      </SearchFieldWrapper>
      <Box
        sx={{
          flex: fillHeight ? '1 1 auto' : undefined,
          minHeight: fillHeight ? 0 : undefined,
          overflowY: fillHeight ? 'auto' : undefined,
        }}
      >
        <OptionsList
          fillHeight={fillHeight}
          options={options}
          selectedValues={value}
          query={query}
          onSelect={handleSelectMultiple}
          isLoadingOptions={false}
          canReorder={canReorder}
        />
      </Box>
    </Box>
  );
};

export default memo(StaticOptionsSelectorV2);
